import React from 'react';
import { UserContext } from '../UserProvider';

export const DataContext = React.createContext();

const ENDPOINT = process.env.REACT_APP_API_URL;

function DataProvider({ children }) {
  const [items, setItems] = React.useState([]);
  const [apiWasRequested, setApiWasRequested] = React.useState(false);
  const [requestWasHandled, setRequestWasHandled] = React.useState(false);
  const [reminderBeingEdited, setReminderBeingEdited] = React.useState(null);
  const [reminderDialogOpen, setReminderDialogOpen] = React.useState(false);
  const [editAll, setEditAll] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState('');

  const [remindersList, setRemindersList] = React.useState([]);
  const [remindersWereRequested, setRemindersWereRequested] =
    React.useState(true);
  const [remindersWereFetched, setRemindersWereFetched] = React.useState(false);

  const { token } = React.useContext(UserContext);

  React.useEffect(() => {
    async function getReminders() {
      const URL = ENDPOINT + `reminder`;
      const HEADERS = {
        'Content-Type': 'application/json',
        Authorization: token,
      };
      const request = new Request(URL, {
        method: 'GET',
        headers: HEADERS,
        timeout: 100000,
      });
      const response = await fetch(request);
      const json = await response.json();
      setRemindersList((oldData) => json);
      return json;
    }
    if (remindersWereRequested && !remindersWereFetched && token) {
      getReminders();
      setRemindersWereRequested(false);
      setRemindersWereFetched(true);
    }
  }, [remindersWereRequested, remindersWereFetched, token]);

  function createItem(content, variant) {
    const nextItems = [
      ...items,
      {
        id: crypto.randomUUID(),
        content,
        variant,
      },
    ];

    setItems(nextItems);
  }

  const createReminder = async (body) => {
    const URL = ENDPOINT + `reminder`;
    const HEADERS = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    const BODY = JSON.stringify(body);
    const request = new Request(URL, {
      method: 'POST',
      headers: HEADERS,
      timeout: 100000,
      body: BODY,
    });

    setRemindersList((old) => {
      const newReminder = {
        reminder: body.reminder,
        datetime: body.datetime,
        KEY: body.id,
        PK1: 'REMINDER',
        SK1: body.id,
      };
      const next = [...old, newReminder];
      // Sort by KEY (ULID is lexically sortable)
      next.sort((a, b) => a.KEY.localeCompare(b.KEY));
      return next;
    });

    const result = fetch(request);
  };

  const updateReminder = async (body) => {
    const URL = ENDPOINT + `reminder`;
    const HEADERS = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    const BODY = JSON.stringify(body);
    console.log(`BODY=${JSON.stringify(BODY)}`);
    const request = new Request(URL, {
      method: 'PUT',
      headers: HEADERS,
      timeout: 100000,
      body: BODY,
    });

    setRemindersList((old) => {
      const newReminder = {
        reminder: body.reminder,
        datetime: body.datetime,
        KEY: body.id,
        PK1: 'REMINDER',
        SK1: body.id,
      };
      const nextItems = old.filter((item) => {
        return item.KEY !== body.prev_id;
      });
      const next = [...nextItems, newReminder];

      // Sort by KEY (ULID is lexically sortable)
      next.sort((a, b) => a.KEY.localeCompare(b.KEY));
      return next;
    });

    const result = fetch(request);
  };

  const deleteReminder = async (id, shouldDeleteAll) => {
    const URL =
      ENDPOINT + `reminder?key=${id}&shouldDeleteAll=${shouldDeleteAll}`;
    const HEADERS = {
      'Content-Type': 'application/json',
      Authorization: token,
    };
    const request = new Request(URL, {
      method: 'DELETE',
      headers: HEADERS,
      timeout: 100000,
    });
    try {
      const result = await fetch(request);
      if (!result.ok) {
        console.error(`Server error: ${result.status}`);
        // do nothing
      }
    } catch (err) {
      console.error('Network or other fetch error:', err);
      // do nothing
    }
    setRemindersList((oldItems) => {
      const nextItems = oldItems.filter((item) => {
        return (
          item.KEY !== id &&
          (!shouldDeleteAll || item.reminder !== reminderBeingEdited.reminder)
        );
      });
      return nextItems;
    });
  };

  function clearItem(id) {
    const nextItems = items.filter((item) => {
      return item.id !== id;
    });
    setItems(nextItems);
  }

  return (
    <DataContext.Provider
      value={{
        items,
        createItem,
        clearItem,
        setApiWasRequested,
        setRequestWasHandled,
        remindersList,
        setRemindersList,
        deleteReminder,
        updateReminder,
        createReminder,
        reminderBeingEdited,
        setReminderBeingEdited,
        reminderDialogOpen,
        setReminderDialogOpen,
        editAll,
        setEditAll,
        searchTerm,
        setSearchTerm,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export default DataProvider;
